import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AgConvergeImage from '../images/Agconverge.png';
import StartupShowcaseImg from '../images/image2.png';
import FarmerTechImg from '../images/FarmerTechAdoptionChallenge.jpg';
import IndustryAcademicImg from '../images/IndustryAcademicPanel.jpg';
import TechDemoImg from '../images/TechnologyDemonstrations.jpg';
import InnovationImg from '../images/InnovationShowcase.jpg';
import HarvestHorizonHero from '../components/HarvestHorizonHero';
import '../styles/HarvestHorizonHero.css';
import NetworkImg from '../images/NetworkingSessions.jpg';

const AgConverge = () => {
  const navigate = useNavigate();

  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0
  });

  useEffect(() => {
    const eventDate = new Date('2025-11-24T12:00:00');

    const updateCountdown = () => {
      const now = new Date();
      const diff = eventDate - now;

      if (diff > 0) {
        setTimeLeft({
          days: Math.floor(diff / (1000 * 60 * 60 * 24)),
          hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
        });
      }
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 60000);

    return () => clearInterval(timer);
  }, []);

  const highlights = [
    {
      image: StartupShowcaseImg,
      useImage: true,
      title: 'Startup Showcases',
      description: 'Lightning talks from innovative agtech startups featuring live demos and interactive Q&A with farmers and industry experts.',
      clickable: true,
      route: '/startup-showcases'
    },
    {
      image: FarmerTechImg,
      useImage: true,
      title: 'Farmer Tech Adoption Challenge',
      description: 'Producer-led discussions focusing on real-world challenges and feedback sessions to guide future technology development.',
      clickable: true,
      route: '/farmer-tech-challenge'
    },
    {
      image: IndustryAcademicImg,
      useImage: true,
      title: 'Industry Academic Panel',
      description: 'Expert discussions on research translation, workforce development, and collaborative opportunities in agricultural innovation.',
      clickable: true,
      route: '/industry-academic-panel'
    },
    {
      image: TechDemoImg,
      useImage: true,
      title: 'Technology Demonstrations',
      description: 'Hands-on stations showcasing cutting-edge agricultural technologies including regional and global startup companies.',
      clickable: false
    },
    {
      image: InnovationImg,
      useImage: true,
      title: 'Innovation Showcase',
      description: 'Student led ag robotics and precision agtech showcase highlighting breakthrough technologies developed at the University of Nebraska-Lincoln.',
      clickable: false
    },
    {
      image: NetworkImg,
      useImage: true,
      title: 'Networking Sessions',
      description: 'Structured networking opportunities connecting producers, startups, researchers, and industry partners for meaningful collaborations.',
      clickable: false
    }
  ];

  const schedule = [
    {
      time: '9:00 AM - 9:30 AM',
      session: 'Registration & Coffee Networking',
      description: 'Farmers, startups, industry, and academics check in. Coffee/tea and light breakfast available. Startup and sponsor booths open. Tech & robotics demonstrations open.'
    },
    {
      time: '9:30 AM - 9:45 AM',
      session: 'Spur Inaugural Remarks',
      description: 'Mark Stone & Ankit Chandra.'
    },
    {
      time: '9:45 AM - 10:00 AM',
      session: 'Keynote',
      description: 'Roric Paulman, Grower at Paulman\'s Farm - Vision for Ag, Water, and Food Innovation.'
    },
    {
      time: '10:00 AM - 10:15 AM',
      session: 'Transition/Networking Break',
      description: 'Short break for networking and refreshments'
    },
    {
      time: '10:15 AM - 11:15 AM',
      session: 'Startup Pitches — Part I',
      description: '3-4 startup pitches (5 minutes each including transition). Startups present innovative solutions across water & irrigation, livestock health, soil management, and digital agriculture.'
    },
    {
      time: '11:15 AM - 11:45 AM',
      session: 'Startup Pitches — Part II',
      description: '3-4 startup pitches (5 minutes each). Continuation of startup presentations showcasing cutting-edge agtech solutions.'
    },
    {
      time: '11:45 AM - 12:15 PM',
      session: 'Lunch & Special Address',
      description: 'Lunch served. Aman Anand, Senior Leader – Independent Agtech and IP strategy consultant at Nutrien Ag - Special Address on the current state of agtech investment and adoption.'
    },
    {
      time: '12:30 PM - 1:45 PM',
      session: 'Farm Tech Adoption Challenge',
      description: 'Farmers gather at themed tables (irrigation, nitrogen, animal health, food systems, digital). Evaluate startup solutions using the Adoption Game: Adoption, barriers and conditions that must be addressed, practice or behavioral changes farmers would commit to if adoption occurs.'
    },
    {
      time: '1:45 PM - 2:30 PM',
      session: 'Table Pitch Backs & Awards',
      description: 'Each table nominates a Farmer Champion to share adoption decisions. Judges score outputs live. Recognition of top 3 farmer tables with awards.'
    },
    {
      time: '2:30 PM - 3:15 PM',
      session: 'Industry–Academia Panel',
      description: 'Discussion on how academia, growers and industry can co-develop solutions for food and water security, accelerate innovation and commercialization of technologies, and address curriculum gaps and workforce needs.'
    },
    {
      time: '3:15 PM - 5:00 PM',
      session: 'Networking & Tech Showcase',
      description: 'Coffee/drink conversations. Tech & robotics demonstrations. Startup and sponsor booth visits. Final networking opportunities before departing.'
    }
  ];

  const nearbyHotels = [
    {
      name: 'Comfort Inn & Suites',
      location: 'Gothenburg, NE',
      distance: 'Adjacent to venue',
      rooms: '74 rooms available',
      phone: '(308) 537-7378',
      features: ['Continental Breakfast', 'Free WiFi', 'Fitness Center', 'Indoor Pool']
    },
    {
      name: 'Cobblestone Hotel & Suites',
      location: 'Cozad, NE',
      distance: '15 minutes from venue',
      phone: '(308) 784-3700',
      features: ['Complimentary Breakfast', 'Free WiFi', 'Business Center', 'Pet Friendly']
    }
  ];

  const registrationUrl = 'https://cvent.me/kY4WxR';

  const handleRegistration = () => {
    window.open(registrationUrl, '_blank');
  };

  const handleHighlightClick = (highlight) => {
    if (highlight.clickable && highlight.route) {
      navigate(highlight.route);
    }
  };

  return (
    <div className="agconverge-page">
      {/* Event Header */}
      {/* Event Header */}
      <div className="event-header">
        <div className="container">
          <div className="event-announcement">
            <h4>Join our official in-person launch event</h4>
            <h1>The Spur AgConverge '26</h1>
            <p className="event-tagline">Where Innovation Meets the Farms</p>
            <div className="event-details">
              <span><i className="far fa-calendar"></i> Nov 17 & Nov 18, 2026</span>
              <span><i className="far fa-clock"></i> 9:00am - 5:00pm</span>
              <span><i className="fas fa-map-marker-alt"></i> Bayer Water Utilization Learning Center, Gothenburg, NE</span>
            </div>
          </div>
          <div className="header-buttons">
            <button className="register-btn" onClick={handleRegistration}>
              Register Now
            </button>
          </div>
        </div>
      </div>

      {/* Hero Section with Image */}
      <div className="hero-illustration">
        <img
          src={AgConvergeImage}
          alt="AgConverge farm scene illustration with farmer, crops, and rolling hills"
          className="hero-image"
        />
      </div>

      {/* Countdown Section */}
      <section className="countdown-section">
        <div className="container">
          <h3 className="countdown-title">Event Countdown</h3>
          <div className="countdown-timer">
            <div className="countdown-item">
              <div className="countdown-number">{timeLeft.days}</div>
              <div className="countdown-label">Days</div>
            </div>
            <div className="countdown-item">
              <div className="countdown-number">{timeLeft.hours}</div>
              <div className="countdown-label">Hours</div>
            </div>
            <div className="countdown-item">
              <div className="countdown-number">{timeLeft.minutes}</div>
              <div className="countdown-label">Minutes</div>
            </div>
          </div>
        </div>
      </section>

      {/* Event Highlights */}
      <section className="highlights-section">
        <div className="container">
          <h2>Event Highlights</h2>
          <div className="highlights-grid">
            {highlights.map((highlight, index) => (
              <div
                key={index}
                className={`highlight-card ${highlight.clickable ? 'clickable' : ''} ${highlight.useImage ? 'has-image' : ''}`}
                onClick={() => handleHighlightClick(highlight)}
                style={{ cursor: highlight.clickable ? 'pointer' : 'default' }}
              >
                {highlight.useImage && highlight.image ? (
                  <>
                    <div className="highlight-image-wrapper">
                      <img
                        src={highlight.image}
                        alt={highlight.title}
                        className="highlight-card-image"
                      />
                    </div>
                    <div className="highlight-content">
                      <h3>{highlight.title}</h3>
                      <p>{highlight.description}</p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="highlight-icon">{highlight.icon}</div>
                    <div className="highlight-content">
                      <h3>{highlight.title}</h3>
                      <p>{highlight.description}</p>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* AGENDA SECTION */}
      <section className="agenda-section">
        <div className="container">
          <h2 className="section-title">Event Agenda</h2>
          <p className="section-subtitle" style={{ marginBottom: '40px' }}>
            <strong>Date:</strong> Monday, November 24, 2025 | <strong>Time:</strong> 9:00 AM - 5:00 PM
          </p>

          <div className="schedule-section">
            {schedule.map((item, index) => (
              <div key={index} className="schedule-item">
                <div className="schedule-time">{item.time}</div>
                <div className="schedule-details">
                  <h3>{item.session}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="announcement-box" style={{ marginTop: '30px' }}>
            <h4>Important Notes</h4>
            <p>
              • Registration opens at 9:00 AM - please arrive on time to check in<br />
              • Light breakfast and coffee will be available during registration<br />
              • Business casual attire recommended<br />
              • Parking is available on-site at Bayer Water Utilization Learning Center<br />
              • Startup and sponsor booths will be open throughout the day
            </p>
          </div>
        </div>
      </section>

      {/* VENUE & HOTEL SECTION */}
      <section className="hotel-section">
        <div className="container">
          <h2 className="section-title">Venue & Hotel Information</h2>

          {/* Venue Information */}
          <div className="content-card">
            <h3>Event Venue</h3>
            <div className="venue-info">
              <h4>Raising Nebraska</h4>
              <p className="venue-address">
                <i className="fas fa-map-marker-alt"></i>
                <strong>Address:</strong> Grand Island, Nebraska 69138
              </p>
              <p className="venue-details">
                The Bayer Water Utilization Learning Center serves as a premier agricultural research and demonstration
                facility, making it the perfect location for AgConverge '25. The center features
                state-of-the-art conference facilities, hands-on demonstration areas, and cutting-edge technology showcases.
              </p>

              <div className="features-grid" style={{ marginTop: '30px' }}>
                <div className="feature-card">
                  <i className="fas fa-parking feature-icon"></i>
                  <h3>Free Parking</h3>
                  <p>Ample on-site parking available</p>
                </div>
                <div className="feature-card">
                  <i className="fas fa-wheelchair feature-icon"></i>
                  <h3>Accessible</h3>
                  <p>ADA compliant facilities</p>
                </div>
                <div className="feature-card">
                  <i className="fas fa-wifi feature-icon"></i>
                  <h3>WiFi</h3>
                  <p>High-speed internet available</p>
                </div>
                <div className="feature-card">
                  <i className="fas fa-utensils feature-icon"></i>
                  <h3>Catering</h3>
                  <p>Breakfast and lunch provided</p>
                </div>
              </div>
            </div>
          </div>

          {/* Hotels Section */}
          <div className="content-card" style={{ marginTop: '40px' }}>
            <h3>Recommended Hotels</h3>
            <p style={{ marginBottom: '30px' }}>
              We recommend booking your accommodation early. Below are nearby hotels that offer
              convenient access to the Bayer Water Utilization Learning Center.
            </p>

            <div className="hotels-list">
              {nearbyHotels.map((hotel, index) => (
                <div key={index} className="hotel-card">
                  <div className="hotel-header">
                    <h4>{hotel.name}</h4>
                    <span className="hotel-distance">{hotel.distance}</span>
                  </div>
                  <div className="hotel-details">
                    <p>
                      <i className="fas fa-map-marker-alt"></i> {hotel.location}
                    </p>
                    {hotel.rooms && (
                      <p>
                        <i className="fas fa-bed"></i> {hotel.rooms}
                      </p>
                    )}
                    <p className="hotel-phone">
                      <i className="fas fa-phone"></i>
                      <a href={`tel:${hotel.phone}`}>{hotel.phone}</a>
                    </p>
                  </div>
                  <div className="hotel-features">
                    <strong>Amenities:</strong>
                    <ul>
                      {hotel.features.map((feature, idx) => (
                        <li key={idx}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Travel Information */}
          <div className="content-card" style={{ marginTop: '40px' }}>
            <h3>Getting to Gothenburg</h3>

            <h4>By Car</h4>
            <p>
              Gothenburg is conveniently located along Interstate 80 in central Nebraska.
            </p>

            <h4>By Air</h4>
            <p>
              The nearest airports are:
            </p>
            <div className="airports-grid">
              <div className="airport-card">
                <h4>North Platte-Lee Bird Regional Airport (LBF)</h4>
                <p>North Platte, NE</p>
              </div>
              <div className="airport-card">
                <h4>Eppley Airfield (OMA)</h4>
                <p>Omaha, NE</p>
              </div>
              <div className="airport-card">
                <h4>Lincoln Airport (LNK)</h4>
                <p>Lincoln, NE</p>
              </div>
              <div className="airport-card">
                <h4>Denver International (DEN)</h4>
                <p>Denver, CO</p>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="content-card" style={{ marginTop: '40px' }}>
            <h3>Need Help?</h3>
            <p>
              If you have questions about accommodations or travel arrangements, please
              contact us using the contact form.
            </p>
            <div className="contact-info-box">
              <p>
                <strong>Event Website:</strong> <a href="https://www.thespur.org/agconverge" target="_blank" rel="noopener noreferrer">www.thespur.org/agconverge</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Registration CTA */}
      <section className="registration-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Join AgConverge '25?</h2>
            <p>Be part of the agricultural innovation revolution. Connect with farmers, startups, researchers, and industry leaders who are shaping the future of agriculture.</p>
            <div className="cta-features">
              <div className="feature">✓ Networking lunch included</div>
              <div className="feature">✓ Hands-on technology demos</div>
              <div className="feature">✓ Direct farmer feedback</div>
            </div>
            <button className="btn-primary large" onClick={handleRegistration}>
              Register Now
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AgConverge;